import React,{ Component } from "react";
import { InputField } from "../../../common/custom-form/input-filter-component";
import DATEPICKER_OR from "../../../common/custom-form/custom-date-picker.component";
import { Button } from "react-bootstrap";
import InvoiceComment from "../../../common/report/reports/Invoice/manage-invoice/invoice-comment.component";
import  InvoiceHistory from "../../../common/report/reports/Invoice/manage-invoice/invoice-history.component";
import { SelectField } from "../../../common/custom-form/select-filter.component";
import ManageLayout from "../../../common/report/details/manage-report.component";
import { DetailsDataTable } from "../../inventory/DetailsView/details-table/details-table.component";
import { CustomDropdown } from "../../../common/custom-form/custom-dropdown.component";
import { AddInformation } from "./order-circuit-add-information";
import { AddCostAllocation } from "./order-add-cost-allocation";
import { Selected_Index } from "../../../../constants/internal-constants";
export default class OrderCircuitDetails extends Component{
    constructor(props){
        super(props);
        this.getDataSelected=this.getDataSelected.bind(this);       
        this.CloseForm=this.CloseForm.bind(this);
        this.state={
            selectFilter:[
                {
                    "FilterId":5,
                    "FilterName":"Account Number",
                    "FilterType":"Textbox",
                    "Page":"CircuitInventoryReport",
                    "State":true,"Createdby":null,
                    "DateCreated":"0001-01-01T00:00:00",
                    "Modifiedby":null,
                    "DateModified":null,
                    "DropDownFilterOpts":null
                },
                {
                    "FilterId":4,
                    "FilterName":"Circuit ID",
                    "FilterType":"Textbox","Page":
                    "CircuitInventoryReport",
                    "State":true,"Createdby":null,
                    "DateCreated":"0001-01-01T00:00:00",
                    "Modifiedby":null,
                    "DateModified":null,
                    "DropDownFilterOpts":null
                },
                {
                    "FilterId":7,
                    "FilterName":"Circuit Status",
                    "FilterType":"Textbox",
                    "Page":"CircuitInventoryReport",
                    "State":true,"Createdby":null,
                    "DateCreated":"0001-01-01T00:00:00",
                    "Modifiedby":null,
                    "DateModified":null,
                    "DropDownFilterOpts":null
                }
               ],
            filterSelected: "", 
            inputValue: "",
            invoiceDate: "",
            invoiceApproveDate: "",
            invoiceDueDate: "",
            billingPeriodDate: "",
            invoiceExpectedDate: "",
            rentalPeriodDate: "",
            actualInvoiceMonth: "",
            invoiceReceiptDate: "",
            beginDate: "",
            endDate: "",
            dataTable:[
                {              
                    HeaderItem:[
                        {
                            name:"Contract Name"
                        },
                        {
                            name:"Vendor"
                        }, {
                            name:"Status"
                        }
                    ],
                    dataItem:[{            
                        columnItem1:"3G Hutchison (GB) Contract",
                        columnItem2: "3G Hutchison (GB)",
                        columnItem3: "Expired"                       
                    }, {            
                        columnItem1:"3G Hutchison (GB) Contract",
                        columnItem2: "3G Hutchison (GB)",
                        columnItem3: "Expired"
                    },{            
                        columnItem1:"3G Hutchison (GB) Contract",
                        columnItem2: "3G Hutchison (GB)",
                        columnItem3: "Expired"
                    }        
                    ]
    
                }
            ],
            selectedIndex:"0", 
            dataSelected:0,
            tableSelected:false,
            listTabInfo:{
                Tab:[
                    {
                        "id":"0",
                        "label":"Subscription Details"            
                    },
                    {
                        "id":"2",
                        "label":"Comments"           
                    }
                ]
            },
            dataInfo:[
                {
                    "name " : "Johny Deep",
                    "date " : "June 08, 2021",
                    "time" : "4:00 PM",
                     "comment" :[
                         "Update-Circuit ID: 0",
                         "Order Submit Date: From: May 31, 2021 at 4:00PM TO: June 07, 2021 at 4:00 AM",
                         "Order Circuit Required Date: From: TO: June  07, 2021 at 4:00PM"
                     ]
                }
            ],
            commentData:[
                {
                    "name " : "Johny Deep",
                    "date " : "June 08, 2021",
                    "time" : "4:00 PM",
                     "comment" :[
                         "Update-Circuit ID: 0"                         
                     ]
                },
                {
                    "name " : "Johny Deep",
                    "date " : "June 08, 2021",
                    "time" : "4:00 PM",
                     "comment" :[                         
                         "Order Circuit Required Date: From: TO: June  07, 2021 at 4:00PM"
                     ]
                }
            ],
            statusList:[
                {
                    "status":"Order Created",
                    "dateCompleted": "29/09/2022"
                },
                {
                    "status":"Order Submitted"                
                },
                {
                    "status":"Order Receipt Confirmed"                    
                },
                {
                    "status":"Circuit Installed"                    
                }

            ]

        }
    }

    getDataSelected(data) {
        this.setState({selectedIndex:data})
       
    }

    openLineItem(data) {
        this.setState({tableSelected:data})
    }
    
    CloseForm() {       
        this.props.closeForm(false)
     }

    render(){   
        const {selectFilter,dataInfo,startDate,dataTable,listTabInfo,tableSelected,selectedIndex}=this.state;           
        return(

            <ManageLayout customClassName="manage-order-circuit-table manage-order-table" buttonLabel="Back to Ciruit Details" haveStatusLabel={false} onGetSelected={this.getDataSelected.bind(this)} statusList={this.state.statusList} closeForm={this.props.closeForm} listData={listTabInfo.Tab} haveHeaderButton={false}>

                {
                    selectedIndex===Selected_Index.i_Zero &&
                        <>
                            <div className="manage-order-container">
                                <div className="manage-order-detail">
                                    <InputField label="CIRCUIT ID" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                                    <SelectField label="BILLING ACCOUNT #"  options={selectFilter} selected={this.state.filterSelected} onChange={(e)=>this.setState({filterSelected:e.target.value})}/>                                
                                    <InputField label="CONTRACT" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                                    <InputField label="VENDOR" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />                                    
                                    <InputField label="CURRENCY" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                                    <SelectField label="STATUS"  options={selectFilter} selected={this.state.filterSelected} onChange={(e)=>this.setState({filterSelected:e.target.value})}/>   
                                    <SelectField label="USER/HR ID"  options={selectFilter} selected={this.state.filterSelected} onChange={(e)=>this.setState({filterSelected:e.target.value})}/>   
                                    <InputField label="USER NAME" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                                    <InputField label="EMAIL ADDRESS" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                                    <SelectField label="LINKED CIRCUIT"  options={selectFilter} selected={this.state.filterSelected} onChange={(e)=>this.setState({filterSelected:e.target.value})}/>   
                                    <InputField label="MRC" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                                    <InputField label="CIRCUIT RANKING" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                                    <InputField label="LINE ITEM TEXT" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                                    <DATEPICKER_OR label="DATE" startDate={this.state.invoiceApproveDate} dateSelected={this.state.invoiceApproveDate} selectedDate={(date) => this.setState({invoiceApproveDate:date})}/>
                                    <DATEPICKER_OR label="DISCONNECT DATE" startDate={this.state.invoiceApproveDate} dateSelected={this.state.invoiceApproveDate} selectedDate={(date) => this.setState({invoiceApproveDate:date})}/>
                                 </div>
                             </div>
                             <h1>POS/Circuit Details</h1>
                             <div className="manage-order-container">
                                <div className="custom-col-350-4 manage-order-details">
                                    <InputField label="PLAN NAME" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                                    <InputField label="PLAN COMPONENTS" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                                    <InputField label="MRC" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                                    <div className="label-button-container">                                        
                                        <Button className="line-item-cancel-button"> Cancel </Button>
                                        <Button className="line-item-save-button"> Add </Button>
                                    </div>                                      
                                </div>
                                <DetailsDataTable datatable={this.state.dataTable} haveEditBtn={true} haveDeleteBtn={true} />                                  

                             </div>  
                             <div className="manage-order-container">
                            
                            <CustomDropdown label="Access Information">
                                <AddInformation />
                            </CustomDropdown>

                            <CustomDropdown label="Add Equipment">
                            </CustomDropdown> 

                            <CustomDropdown label="Add Cost Allocation">
                                <AddCostAllocation dataTable={this.state.dataTable}/>
                            </CustomDropdown>                             
                            
                              
                             </div>    
                             <div className="save-btn-container">
                                 <Button className="save-button" onClick={this.CloseForm}> Back to Circuit Details </Button>  
                             </div>                                
                        </>
                }

                {
                    selectedIndex===Selected_Index.i_One &&
                    < InvoiceHistory dataInfo={dataInfo}/>
                }

                {
                    selectedIndex===Selected_Index.i_Two &&
                    <InvoiceComment dataInfo={this.state.commentData}/>
                }

            </ManageLayout>
        )
    }
}